package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * San Marino Flag (32x24dp)
 *
 * - ISO Alpha-2: SM
 * - ISO Alpha-3: SMR
 * - ISO Numeric: 674
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.SanMarino: ImageVector by lazy {
    ImageVector.Builder(
        name = "San Marino:SM:SMR:674:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFF56C6F5)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 12f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(12f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF006923)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(10.254f, 9.028f)
                curveTo(10.247f, 8.944f, 10.229f, 8.871f, 10.198f, 8.814f)
                curveTo(9.942f, 8.335f, 10.025f, 7.736f, 10.025f, 7.736f)
                curveTo(10.025f, 7.736f, 9.718f, 8.438f, 9.538f, 9.098f)
                curveTo(9.349f, 8.791f, 9.283f, 8.482f, 9.283f, 8.482f)
                curveTo(9.283f, 8.482f, 9.16f, 10.42f, 9.535f, 10.879f)
                curveTo(9.909f, 11.338f, 10.158f, 11.54f, 10.158f, 11.54f)
                curveTo(10.158f, 11.54f, 10.187f, 10.735f, 10.078f, 10.106f)
                curveTo(10.155f, 9.844f, 10.224f, 9.556f, 10.249f, 9.309f)
                curveTo(10.298f, 9.272f, 10.427f, 9.175f, 10.589f, 9.043f)
                curveTo(10.521f, 9.42f, 10.518f, 9.624f, 10.518f, 9.624f)
                curveTo(10.518f, 9.624f, 11.928f, 8.6f, 11.964f, 8.058f)
                curveTo(12f, 7.516f, 12.388f, 7.052f, 12.388f, 7.052f)
                curveTo(12.388f, 7.052f, 12.067f, 7.271f, 11.701f, 7.565f)
                curveTo(11.798f, 7.11f, 12.097f, 6.752f, 12.097f, 6.752f)
                curveTo(12.097f, 6.752f, 10.495f, 7.848f, 10.364f, 8.426f)
                curveTo(10.307f, 8.677f, 10.274f, 8.88f, 10.254f, 9.028f)
                close()
                moveTo(10.323f, 12.359f)
                curveTo(10.169f, 12.069f, 9.501f, 10.853f, 9.034f, 10.747f)
                curveTo(8.504f, 10.627f, 8.107f, 10.171f, 8.107f, 10.171f)
                curveTo(8.107f, 10.171f, 8.939f, 11.925f, 9.489f, 12.145f)
                curveTo(9.931f, 12.322f, 10.222f, 12.392f, 10.319f, 12.413f)
                curveTo(10.303f, 12.65f, 10.3f, 12.813f, 10.3f, 12.813f)
                curveTo(10.3f, 12.813f, 10.56f, 12.625f, 10.958f, 12.186f)
                curveTo(11.356f, 11.747f, 11.335f, 9.806f, 11.335f, 9.806f)
                curveTo(11.335f, 9.806f, 11.177f, 10.39f, 10.753f, 10.73f)
                curveTo(10.469f, 10.958f, 10.362f, 11.818f, 10.323f, 12.359f)
                close()
                moveTo(9.071f, 12.175f)
                curveTo(9.677f, 12.172f, 10.608f, 13.656f, 10.608f, 13.656f)
                curveTo(10.608f, 13.656f, 10.247f, 13.676f, 9.617f, 13.576f)
                curveTo(8.987f, 13.477f, 8.004f, 11.785f, 8.004f, 11.785f)
                curveTo(8.004f, 11.785f, 8.466f, 12.179f, 9.071f, 12.175f)
                close()
                moveTo(12.022f, 15.632f)
                curveTo(12.022f, 15.632f, 12.381f, 13.741f, 11.842f, 13.3f)
                curveTo(11.302f, 12.859f, 11.207f, 12.2f, 11.207f, 12.2f)
                curveTo(11.207f, 12.2f, 10.728f, 14.297f, 11.207f, 14.841f)
                curveTo(11.686f, 15.384f, 12.022f, 15.632f, 12.022f, 15.632f)
                close()
                moveTo(9.846f, 15.122f)
                curveTo(10.198f, 15.539f, 11.32f, 15.122f, 11.32f, 15.122f)
                curveTo(11.32f, 15.122f, 11.567f, 15.346f, 10.677f, 14.533f)
                curveTo(9.787f, 13.719f, 7.977f, 14.233f, 8.464f, 14.233f)
                curveTo(8.951f, 14.233f, 9.493f, 14.704f, 9.846f, 15.122f)
                close()
                moveTo(10.677f, 17.342f)
                curveTo(11.33f, 17.895f, 12.741f, 16.58f, 12.741f, 16.58f)
                curveTo(12.741f, 16.58f, 12.378f, 16.14f, 11.705f, 15.816f)
                curveTo(11.032f, 15.492f, 8.549f, 15.816f, 8.549f, 15.816f)
                lineTo(9.654f, 16.308f)
                curveTo(9.654f, 16.308f, 8.424f, 16.789f, 8.75f, 16.762f)
                curveTo(9.077f, 16.735f, 10.024f, 16.789f, 10.677f, 17.342f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF009933)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(19.213f, 16.196f)
                curveTo(19.213f, 16.196f, 18.652f, 15.253f, 19.213f, 14.797f)
                curveTo(19.775f, 14.342f, 19.997f, 14.645f, 19.997f, 14.121f)
                curveTo(19.997f, 13.597f, 20.054f, 13.753f, 20.33f, 13.493f)
                curveTo(20.605f, 13.233f, 20.41f, 12.601f, 20.779f, 12.917f)
                curveTo(21.149f, 13.233f, 21.218f, 12.627f, 21.218f, 13.885f)
                curveTo(21.218f, 15.144f, 21.218f, 12.744f, 21.218f, 12.037f)
                curveTo(21.218f, 11.33f, 20.779f, 11.497f, 20.779f, 11.023f)
                curveTo(20.779f, 10.549f, 20.341f, 9.841f, 20.779f, 9.841f)
                curveTo(21.218f, 9.841f, 21.476f, 10.368f, 21.476f, 10.368f)
                curveTo(21.476f, 10.368f, 21.906f, 11.102f, 21.906f, 10.368f)
                curveTo(21.906f, 9.634f, 21.139f, 9.852f, 20.779f, 9.042f)
                curveTo(20.42f, 8.232f, 20.476f, 9.133f, 19.997f, 8.089f)
                curveTo(19.518f, 7.045f, 18.947f, 6.714f, 19.472f, 6.714f)
                curveTo(19.997f, 6.714f, 19.88f, 6.714f, 20.33f, 6.714f)
                curveTo(20.779f, 6.714f, 21.476f, 6.34f, 21.476f, 6.714f)
                curveTo(21.476f, 7.087f, 21.476f, 6.916f, 21.476f, 7.503f)
                curveTo(21.476f, 8.089f, 21.906f, 8.089f, 21.906f, 8.089f)
                curveTo(21.906f, 8.089f, 22.14f, 6.916f, 22.435f, 7.503f)
                curveTo(22.729f, 8.089f, 22.528f, 9.042f, 22.744f, 9.042f)
                curveTo(22.959f, 9.042f, 22.781f, 8.057f, 23.251f, 8.812f)
                curveTo(23.721f, 9.566f, 23.251f, 10.077f, 23.251f, 10.368f)
                curveTo(23.251f, 10.659f, 22.744f, 11.372f, 22.744f, 11.372f)
                curveTo(22.744f, 11.372f, 22.843f, 11.721f, 23.251f, 11.372f)
                curveTo(23.659f, 11.023f, 24.046f, 10.675f, 24.046f, 11.023f)
                curveTo(24.046f, 11.372f, 24.842f, 11.48f, 24.046f, 12.037f)
                curveTo(23.251f, 12.593f, 23.758f, 13.151f, 23.251f, 13.151f)
                curveTo(22.744f, 13.151f, 22.146f, 13.885f, 21.906f, 13.885f)
                curveTo(21.666f, 13.885f, 20.769f, 14.448f, 21.218f, 14.448f)
                curveTo(21.666f, 14.448f, 22.125f, 13.323f, 22.435f, 13.885f)
                curveTo(22.744f, 14.448f, 22.74f, 13.794f, 22.995f, 14.121f)
                curveTo(23.251f, 14.448f, 23.507f, 16.221f, 23.251f, 15.509f)
                curveTo(22.995f, 14.797f, 22.595f, 14.797f, 21.906f, 14.797f)
                curveTo(21.218f, 14.797f, 19.88f, 14.849f, 20.33f, 15.179f)
                curveTo(20.779f, 15.509f, 21.285f, 14.849f, 21.476f, 15.179f)
                curveTo(21.666f, 15.509f, 21.611f, 15.84f, 21.906f, 15.509f)
                curveTo(22.202f, 15.179f, 22.492f, 15.509f, 22.744f, 15.509f)
                curveTo(22.995f, 15.509f, 22.492f, 15.879f, 22.744f, 16.196f)
                curveTo(22.995f, 16.514f, 23.556f, 16.937f, 22.995f, 16.937f)
                curveTo(22.435f, 16.937f, 22.146f, 16.488f, 21.906f, 16.937f)
                curveTo(21.666f, 17.385f, 21.656f, 18.163f, 21.218f, 17.55f)
                curveTo(20.779f, 16.937f, 19.997f, 17.248f, 19.997f, 16.937f)
                curveTo(19.997f, 16.625f, 20.168f, 16.575f, 19.691f, 16.575f)
                curveTo(19.213f, 16.575f, 19.213f, 16.196f, 19.213f, 16.196f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFC51918)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(21.516f, 9.45f)
                curveTo(21.516f, 9.588f, 21.408f, 9.7f, 21.274f, 9.7f)
                curveTo(21.141f, 9.7f, 21.032f, 9.588f, 21.032f, 9.45f)
                curveTo(21.032f, 9.312f, 21.141f, 9.2f, 21.274f, 9.2f)
                curveTo(21.408f, 9.2f, 21.516f, 9.312f, 21.516f, 9.45f)
                close()
                moveTo(10.339f, 10f)
                curveTo(10.472f, 10f, 10.581f, 9.888f, 10.581f, 9.75f)
                curveTo(10.581f, 9.612f, 10.472f, 9.5f, 10.339f, 9.5f)
                curveTo(10.205f, 9.5f, 10.097f, 9.612f, 10.097f, 9.75f)
                curveTo(10.097f, 9.888f, 10.205f, 10f, 10.339f, 10f)
                close()
                moveTo(10.581f, 11.05f)
                curveTo(10.581f, 11.188f, 10.472f, 11.3f, 10.339f, 11.3f)
                curveTo(10.205f, 11.3f, 10.097f, 11.188f, 10.097f, 11.05f)
                curveTo(10.097f, 10.912f, 10.205f, 10.8f, 10.339f, 10.8f)
                curveTo(10.472f, 10.8f, 10.581f, 10.912f, 10.581f, 11.05f)
                close()
                moveTo(10.726f, 13.6f)
                curveTo(10.859f, 13.6f, 10.968f, 13.488f, 10.968f, 13.35f)
                curveTo(10.968f, 13.212f, 10.859f, 13.1f, 10.726f, 13.1f)
                curveTo(10.592f, 13.1f, 10.484f, 13.212f, 10.484f, 13.35f)
                curveTo(10.484f, 13.488f, 10.592f, 13.6f, 10.726f, 13.6f)
                close()
                moveTo(12.661f, 16.1f)
                curveTo(12.795f, 16.1f, 12.903f, 15.988f, 12.903f, 15.85f)
                curveTo(12.903f, 15.712f, 12.795f, 15.6f, 12.661f, 15.6f)
                curveTo(12.528f, 15.6f, 12.419f, 15.712f, 12.419f, 15.85f)
                curveTo(12.419f, 15.988f, 12.528f, 16.1f, 12.661f, 16.1f)
                close()
                moveTo(21.952f, 12.3f)
                curveTo(22.085f, 12.3f, 22.194f, 12.188f, 22.194f, 12.05f)
                curveTo(22.194f, 11.912f, 22.085f, 11.8f, 21.952f, 11.8f)
                curveTo(21.818f, 11.8f, 21.71f, 11.912f, 21.71f, 12.05f)
                curveTo(21.71f, 12.188f, 21.818f, 12.3f, 21.952f, 12.3f)
                close()
                moveTo(21.419f, 14.05f)
                curveTo(21.419f, 14.188f, 21.311f, 14.3f, 21.177f, 14.3f)
                curveTo(21.044f, 14.3f, 20.935f, 14.188f, 20.935f, 14.05f)
                curveTo(20.935f, 13.912f, 21.044f, 13.8f, 21.177f, 13.8f)
                curveTo(21.311f, 13.8f, 21.419f, 13.912f, 21.419f, 14.05f)
                close()
                moveTo(19.145f, 16.5f)
                curveTo(19.279f, 16.5f, 19.387f, 16.388f, 19.387f, 16.25f)
                curveTo(19.387f, 16.112f, 19.279f, 16f, 19.145f, 16f)
                curveTo(19.012f, 16f, 18.903f, 16.112f, 18.903f, 16.25f)
                curveTo(18.903f, 16.388f, 19.012f, 16.5f, 19.145f, 16.5f)
                close()
                moveTo(13f, 16.55f)
                curveTo(13f, 16.688f, 12.892f, 16.8f, 12.758f, 16.8f)
                curveTo(12.625f, 16.8f, 12.516f, 16.688f, 12.516f, 16.55f)
                curveTo(12.516f, 16.412f, 12.625f, 16.3f, 12.758f, 16.3f)
                curveTo(12.892f, 16.3f, 13f, 16.412f, 13f, 16.55f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(18.038f, 19.82f)
                curveTo(18.038f, 19.615f, 14.937f, 17.478f, 14.105f, 17.007f)
                curveTo(13.273f, 16.536f, 9.209f, 13.942f, 10.316f, 10f)
                horizontalLineTo(10.148f)
                curveTo(10.148f, 10f, 9.399f, 14.857f, 14.559f, 17.875f)
                curveTo(16.909f, 19.452f, 17.026f, 19.82f, 17.026f, 19.82f)
                curveTo(17.026f, 19.82f, 18.038f, 20.025f, 18.038f, 19.82f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(13.924f, 19.82f)
                curveTo(13.924f, 19.615f, 17.025f, 17.478f, 17.857f, 17.007f)
                curveTo(18.689f, 16.536f, 22.753f, 13.942f, 21.646f, 10f)
                horizontalLineTo(21.814f)
                curveTo(21.814f, 10f, 22.563f, 14.857f, 17.403f, 17.875f)
                curveTo(15.053f, 19.452f, 14.936f, 19.82f, 14.936f, 19.82f)
                curveTo(14.936f, 19.82f, 13.924f, 20.025f, 13.924f, 19.82f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF56C6F5)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(16.048f, 16.886f)
                curveTo(18.213f, 16.886f, 19.968f, 14.084f, 19.968f, 11.35f)
                curveTo(19.968f, 8.616f, 18.213f, 7.2f, 16.048f, 7.2f)
                curveTo(13.884f, 7.2f, 12.129f, 8.616f, 12.129f, 11.35f)
                curveTo(12.129f, 14.084f, 13.884f, 16.886f, 16.048f, 16.886f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(14.313f, 9.539f)
                curveTo(14.313f, 9.539f, 14.917f, 9.006f, 14.615f, 9.006f)
                curveTo(14.557f, 9.006f, 14.485f, 8.995f, 14.408f, 8.983f)
                curveTo(14.089f, 8.931f, 13.673f, 8.865f, 13.673f, 9.539f)
                verticalLineTo(10.697f)
                lineTo(13.673f, 10.7f)
                horizontalLineTo(13.584f)
                curveTo(13.529f, 10.7f, 13.484f, 10.745f, 13.484f, 10.8f)
                curveTo(13.484f, 10.855f, 13.529f, 10.9f, 13.584f, 10.9f)
                horizontalLineTo(13.662f)
                curveTo(13.649f, 11.147f, 13.625f, 11.587f, 13.602f, 12.027f)
                lineTo(13.487f, 12.037f)
                curveTo(13.428f, 12.042f, 13.384f, 12.095f, 13.39f, 12.154f)
                lineTo(13.397f, 12.238f)
                curveTo(13.402f, 12.297f, 13.454f, 12.341f, 13.514f, 12.336f)
                lineTo(13.586f, 12.33f)
                curveTo(13.559f, 12.844f, 13.536f, 13.293f, 13.536f, 13.348f)
                curveTo(13.536f, 13.483f, 14.455f, 13.431f, 14.455f, 13.431f)
                curveTo(14.455f, 13.431f, 14.426f, 12.889f, 14.395f, 12.259f)
                lineTo(14.456f, 12.254f)
                curveTo(14.515f, 12.248f, 14.559f, 12.196f, 14.554f, 12.137f)
                lineTo(14.547f, 12.052f)
                curveTo(14.541f, 11.993f, 14.489f, 11.95f, 14.43f, 11.955f)
                lineTo(14.38f, 11.959f)
                curveTo(14.361f, 11.582f, 14.343f, 11.199f, 14.33f, 10.9f)
                horizontalLineTo(14.448f)
                curveTo(14.504f, 10.9f, 14.548f, 10.855f, 14.548f, 10.8f)
                curveTo(14.548f, 10.745f, 14.504f, 10.7f, 14.448f, 10.7f)
                horizontalLineTo(14.322f)
                curveTo(14.317f, 10.551f, 14.313f, 10.439f, 14.313f, 10.382f)
                verticalLineTo(9.539f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(13.871f, 11f)
                horizontalLineTo(14.194f)
                verticalLineTo(11.43f)
                horizontalLineTo(13.871f)
                verticalLineTo(11f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(13.774f, 12.5f)
                horizontalLineTo(14.312f)
                verticalLineTo(13.5f)
                horizontalLineTo(13.774f)
                verticalLineTo(12.5f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(16.346f, 9.539f)
                curveTo(16.346f, 9.539f, 16.949f, 9.006f, 16.647f, 9.006f)
                curveTo(16.589f, 9.006f, 16.517f, 8.995f, 16.441f, 8.983f)
                curveTo(16.121f, 8.931f, 15.705f, 8.865f, 15.705f, 9.539f)
                verticalLineTo(10.697f)
                lineTo(15.705f, 10.7f)
                horizontalLineTo(15.616f)
                curveTo(15.561f, 10.7f, 15.516f, 10.745f, 15.516f, 10.8f)
                curveTo(15.516f, 10.855f, 15.561f, 10.9f, 15.616f, 10.9f)
                horizontalLineTo(15.694f)
                curveTo(15.681f, 11.147f, 15.657f, 11.587f, 15.634f, 12.027f)
                lineTo(15.52f, 12.037f)
                curveTo(15.46f, 12.042f, 15.417f, 12.095f, 15.422f, 12.154f)
                lineTo(15.429f, 12.238f)
                curveTo(15.434f, 12.297f, 15.487f, 12.341f, 15.546f, 12.336f)
                lineTo(15.618f, 12.33f)
                curveTo(15.591f, 12.844f, 15.569f, 13.293f, 15.569f, 13.348f)
                curveTo(15.569f, 13.483f, 16.487f, 13.431f, 16.487f, 13.431f)
                curveTo(16.487f, 13.431f, 16.458f, 12.889f, 16.427f, 12.259f)
                lineTo(16.489f, 12.254f)
                curveTo(16.548f, 12.248f, 16.591f, 12.196f, 16.586f, 12.137f)
                lineTo(16.579f, 12.052f)
                curveTo(16.574f, 11.993f, 16.521f, 11.95f, 16.462f, 11.955f)
                lineTo(16.412f, 11.959f)
                curveTo(16.393f, 11.582f, 16.375f, 11.199f, 16.363f, 10.9f)
                horizontalLineTo(16.481f)
                curveTo(16.536f, 10.9f, 16.581f, 10.855f, 16.581f, 10.8f)
                curveTo(16.581f, 10.745f, 16.536f, 10.7f, 16.481f, 10.7f)
                horizontalLineTo(16.355f)
                curveTo(16.349f, 10.551f, 16.346f, 10.439f, 16.346f, 10.382f)
                verticalLineTo(9.539f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(15.903f, 11f)
                horizontalLineTo(16.226f)
                verticalLineTo(11.43f)
                horizontalLineTo(15.903f)
                verticalLineTo(11f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(15.807f, 12.5f)
                horizontalLineTo(16.344f)
                verticalLineTo(13.5f)
                horizontalLineTo(15.807f)
                verticalLineTo(12.5f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(18.281f, 9.539f)
                curveTo(18.281f, 9.539f, 18.885f, 9.006f, 18.583f, 9.006f)
                curveTo(18.524f, 9.006f, 18.453f, 8.995f, 18.376f, 8.983f)
                curveTo(18.057f, 8.931f, 17.641f, 8.865f, 17.641f, 9.539f)
                verticalLineTo(10.697f)
                lineTo(17.641f, 10.7f)
                horizontalLineTo(17.552f)
                curveTo(17.496f, 10.7f, 17.452f, 10.745f, 17.452f, 10.8f)
                curveTo(17.452f, 10.855f, 17.496f, 10.9f, 17.552f, 10.9f)
                horizontalLineTo(17.63f)
                curveTo(17.616f, 11.147f, 17.593f, 11.587f, 17.569f, 12.027f)
                lineTo(17.455f, 12.037f)
                curveTo(17.396f, 12.042f, 17.352f, 12.095f, 17.357f, 12.154f)
                lineTo(17.365f, 12.238f)
                curveTo(17.37f, 12.297f, 17.422f, 12.341f, 17.481f, 12.336f)
                lineTo(17.554f, 12.33f)
                curveTo(17.527f, 12.844f, 17.504f, 13.293f, 17.504f, 13.348f)
                curveTo(17.504f, 13.483f, 18.422f, 13.431f, 18.422f, 13.431f)
                curveTo(18.422f, 13.431f, 18.394f, 12.889f, 18.362f, 12.259f)
                lineTo(18.424f, 12.254f)
                curveTo(18.483f, 12.248f, 18.527f, 12.196f, 18.522f, 12.137f)
                lineTo(18.514f, 12.052f)
                curveTo(18.509f, 11.993f, 18.457f, 11.95f, 18.398f, 11.955f)
                lineTo(18.347f, 11.959f)
                curveTo(18.329f, 11.582f, 18.311f, 11.199f, 18.298f, 10.9f)
                horizontalLineTo(18.416f)
                curveTo(18.471f, 10.9f, 18.516f, 10.855f, 18.516f, 10.8f)
                curveTo(18.516f, 10.745f, 18.471f, 10.7f, 18.416f, 10.7f)
                horizontalLineTo(18.29f)
                curveTo(18.284f, 10.551f, 18.281f, 10.439f, 18.281f, 10.382f)
                verticalLineTo(9.539f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(17.839f, 11f)
                horizontalLineTo(18.161f)
                verticalLineTo(11.43f)
                horizontalLineTo(17.839f)
                verticalLineTo(11f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(17.742f, 12.5f)
                horizontalLineTo(18.28f)
                verticalLineTo(13.5f)
                horizontalLineTo(17.742f)
                verticalLineTo(12.5f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(18.516f, 6.4f)
                horizontalLineTo(13.387f)
                verticalLineTo(7.166f)
                lineTo(13.353f, 7.169f)
                curveTo(13.353f, 7.169f, 10.84f, 9.121f, 11.537f, 12.047f)
                curveTo(12.235f, 14.972f, 15.005f, 17.141f, 15.005f, 17.141f)
                lineTo(15.144f, 16.636f)
                curveTo(15.144f, 16.636f, 12.505f, 13.047f, 12.505f, 11.613f)
                curveTo(12.505f, 10.179f, 13.003f, 8.833f, 13.53f, 8.623f)
                curveTo(13.847f, 8.498f, 13.902f, 8.523f, 13.988f, 8.563f)
                curveTo(14.046f, 8.59f, 14.117f, 8.623f, 14.288f, 8.623f)
                curveTo(14.716f, 8.623f, 15.144f, 8.317f, 15.144f, 8.317f)
                curveTo(15.144f, 8.317f, 15.442f, 8.623f, 15.719f, 8.623f)
                curveTo(15.996f, 8.623f, 16f, 8.317f, 16f, 8.317f)
                verticalLineTo(7.3f)
                horizontalLineTo(16.031f)
                verticalLineTo(8.317f)
                curveTo(16.031f, 8.317f, 16.035f, 8.623f, 16.312f, 8.623f)
                curveTo(16.588f, 8.623f, 16.886f, 8.317f, 16.886f, 8.317f)
                curveTo(16.886f, 8.317f, 17.315f, 8.623f, 17.743f, 8.623f)
                curveTo(17.914f, 8.623f, 17.985f, 8.59f, 18.042f, 8.563f)
                curveTo(18.129f, 8.523f, 18.184f, 8.498f, 18.501f, 8.623f)
                curveTo(19.028f, 8.833f, 19.526f, 10.179f, 19.526f, 11.613f)
                curveTo(19.526f, 13.047f, 16.886f, 16.636f, 16.886f, 16.636f)
                lineTo(17.026f, 17.141f)
                curveTo(17.026f, 17.141f, 19.796f, 14.972f, 20.493f, 12.047f)
                curveTo(21.191f, 9.121f, 18.678f, 7.169f, 18.678f, 7.169f)
                lineTo(18.516f, 7.154f)
                verticalLineTo(6.4f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFD018))) {
                moveTo(13.387f, 6.4f)
                verticalLineTo(5.9f)
                horizontalLineTo(12.887f)
                verticalLineTo(6.4f)
                horizontalLineTo(13.387f)
                close()
                moveTo(18.516f, 6.4f)
                horizontalLineTo(19.016f)
                verticalLineTo(5.9f)
                horizontalLineTo(18.516f)
                verticalLineTo(6.4f)
                close()
                moveTo(13.387f, 7.166f)
                lineTo(13.432f, 7.664f)
                lineTo(13.887f, 7.623f)
                verticalLineTo(7.166f)
                horizontalLineTo(13.387f)
                close()
                moveTo(13.353f, 7.169f)
                lineTo(13.308f, 6.671f)
                lineTo(13.162f, 6.684f)
                lineTo(13.046f, 6.774f)
                lineTo(13.353f, 7.169f)
                close()
                moveTo(11.537f, 12.047f)
                lineTo(11.051f, 12.163f)
                lineTo(11.537f, 12.047f)
                close()
                moveTo(15.005f, 17.141f)
                lineTo(14.696f, 17.535f)
                lineTo(15.287f, 17.997f)
                lineTo(15.487f, 17.274f)
                lineTo(15.005f, 17.141f)
                close()
                moveTo(15.144f, 16.636f)
                lineTo(15.626f, 16.77f)
                lineTo(15.691f, 16.536f)
                lineTo(15.547f, 16.34f)
                lineTo(15.144f, 16.636f)
                close()
                moveTo(13.53f, 8.623f)
                lineTo(13.346f, 8.159f)
                lineTo(13.346f, 8.159f)
                lineTo(13.53f, 8.623f)
                close()
                moveTo(13.988f, 8.563f)
                lineTo(13.777f, 9.016f)
                lineTo(13.777f, 9.016f)
                lineTo(13.988f, 8.563f)
                close()
                moveTo(15.144f, 8.317f)
                lineTo(15.503f, 7.968f)
                lineTo(15.203f, 7.66f)
                lineTo(14.854f, 7.91f)
                lineTo(15.144f, 8.317f)
                close()
                moveTo(16f, 8.317f)
                lineTo(16.5f, 8.323f)
                verticalLineTo(8.317f)
                horizontalLineTo(16f)
                close()
                moveTo(16f, 7.3f)
                verticalLineTo(6.8f)
                horizontalLineTo(15.5f)
                verticalLineTo(7.3f)
                horizontalLineTo(16f)
                close()
                moveTo(16.031f, 7.3f)
                horizontalLineTo(16.531f)
                verticalLineTo(6.8f)
                horizontalLineTo(16.031f)
                verticalLineTo(7.3f)
                close()
                moveTo(16.031f, 8.317f)
                horizontalLineTo(15.531f)
                lineTo(15.531f, 8.323f)
                lineTo(16.031f, 8.317f)
                close()
                moveTo(16.886f, 8.317f)
                lineTo(17.177f, 7.91f)
                lineTo(16.827f, 7.66f)
                lineTo(16.528f, 7.968f)
                lineTo(16.886f, 8.317f)
                close()
                moveTo(18.042f, 8.563f)
                lineTo(18.254f, 9.016f)
                lineTo(18.254f, 9.016f)
                lineTo(18.042f, 8.563f)
                close()
                moveTo(18.501f, 8.623f)
                lineTo(18.316f, 9.088f)
                lineTo(18.501f, 8.623f)
                close()
                moveTo(16.886f, 16.636f)
                lineTo(16.483f, 16.34f)
                lineTo(16.34f, 16.536f)
                lineTo(16.404f, 16.77f)
                lineTo(16.886f, 16.636f)
                close()
                moveTo(17.026f, 17.141f)
                lineTo(16.544f, 17.274f)
                lineTo(16.744f, 17.997f)
                lineTo(17.334f, 17.535f)
                lineTo(17.026f, 17.141f)
                close()
                moveTo(18.678f, 7.169f)
                lineTo(18.985f, 6.774f)
                lineTo(18.869f, 6.684f)
                lineTo(18.723f, 6.671f)
                lineTo(18.678f, 7.169f)
                close()
                moveTo(18.516f, 7.154f)
                horizontalLineTo(18.016f)
                verticalLineTo(7.612f)
                lineTo(18.472f, 7.652f)
                lineTo(18.516f, 7.154f)
                close()
                moveTo(13.387f, 6.9f)
                horizontalLineTo(18.516f)
                verticalLineTo(5.9f)
                horizontalLineTo(13.387f)
                verticalLineTo(6.9f)
                close()
                moveTo(13.887f, 7.166f)
                verticalLineTo(6.4f)
                horizontalLineTo(12.887f)
                verticalLineTo(7.166f)
                horizontalLineTo(13.887f)
                close()
                moveTo(13.397f, 7.667f)
                lineTo(13.432f, 7.664f)
                lineTo(13.343f, 6.668f)
                lineTo(13.308f, 6.671f)
                lineTo(13.397f, 7.667f)
                close()
                moveTo(12.024f, 11.931f)
                curveTo(11.716f, 10.64f, 12.111f, 9.559f, 12.606f, 8.778f)
                curveTo(12.853f, 8.388f, 13.122f, 8.08f, 13.328f, 7.87f)
                curveTo(13.43f, 7.765f, 13.517f, 7.686f, 13.576f, 7.634f)
                curveTo(13.605f, 7.608f, 13.628f, 7.589f, 13.642f, 7.577f)
                curveTo(13.65f, 7.571f, 13.655f, 7.567f, 13.658f, 7.565f)
                curveTo(13.659f, 7.564f, 13.66f, 7.563f, 13.66f, 7.563f)
                curveTo(13.66f, 7.563f, 13.66f, 7.563f, 13.66f, 7.563f)
                curveTo(13.66f, 7.563f, 13.66f, 7.563f, 13.66f, 7.563f)
                curveTo(13.66f, 7.563f, 13.66f, 7.563f, 13.66f, 7.563f)
                curveTo(13.66f, 7.563f, 13.66f, 7.564f, 13.353f, 7.169f)
                curveTo(13.046f, 6.774f, 13.046f, 6.774f, 13.045f, 6.774f)
                curveTo(13.045f, 6.774f, 13.045f, 6.774f, 13.045f, 6.775f)
                curveTo(13.045f, 6.775f, 13.045f, 6.775f, 13.044f, 6.775f)
                curveTo(13.043f, 6.776f, 13.042f, 6.777f, 13.041f, 6.777f)
                curveTo(13.039f, 6.779f, 13.037f, 6.781f, 13.033f, 6.784f)
                curveTo(13.027f, 6.789f, 13.018f, 6.796f, 13.007f, 6.805f)
                curveTo(12.985f, 6.824f, 12.954f, 6.849f, 12.916f, 6.883f)
                curveTo(12.841f, 6.949f, 12.736f, 7.045f, 12.614f, 7.169f)
                curveTo(12.371f, 7.417f, 12.055f, 7.78f, 11.761f, 8.243f)
                curveTo(11.174f, 9.17f, 10.661f, 10.528f, 11.051f, 12.163f)
                lineTo(12.024f, 11.931f)
                close()
                moveTo(15.005f, 17.141f)
                curveTo(15.313f, 16.747f, 15.313f, 16.748f, 15.313f, 16.748f)
                curveTo(15.313f, 16.748f, 15.313f, 16.748f, 15.313f, 16.748f)
                curveTo(15.313f, 16.748f, 15.313f, 16.748f, 15.313f, 16.748f)
                curveTo(15.313f, 16.748f, 15.313f, 16.747f, 15.313f, 16.747f)
                curveTo(15.312f, 16.747f, 15.311f, 16.746f, 15.308f, 16.744f)
                curveTo(15.304f, 16.74f, 15.298f, 16.735f, 15.289f, 16.728f)
                curveTo(15.27f, 16.713f, 15.243f, 16.69f, 15.207f, 16.66f)
                curveTo(15.135f, 16.599f, 15.029f, 16.508f, 14.9f, 16.389f)
                curveTo(14.64f, 16.15f, 14.286f, 15.801f, 13.912f, 15.365f)
                curveTo(13.156f, 14.486f, 12.346f, 13.283f, 12.024f, 11.931f)
                lineTo(11.051f, 12.163f)
                curveTo(11.426f, 13.735f, 12.349f, 15.08f, 13.153f, 16.017f)
                curveTo(13.558f, 16.488f, 13.941f, 16.865f, 14.222f, 17.124f)
                curveTo(14.363f, 17.254f, 14.48f, 17.355f, 14.562f, 17.424f)
                curveTo(14.603f, 17.459f, 14.636f, 17.486f, 14.658f, 17.504f)
                curveTo(14.67f, 17.514f, 14.679f, 17.521f, 14.685f, 17.526f)
                curveTo(14.688f, 17.528f, 14.691f, 17.53f, 14.693f, 17.532f)
                curveTo(14.694f, 17.533f, 14.695f, 17.533f, 14.695f, 17.534f)
                curveTo(14.696f, 17.534f, 14.696f, 17.534f, 14.696f, 17.534f)
                curveTo(14.696f, 17.535f, 14.696f, 17.535f, 14.696f, 17.535f)
                curveTo(14.696f, 17.535f, 14.696f, 17.535f, 15.005f, 17.141f)
                close()
                moveTo(14.663f, 16.503f)
                lineTo(14.523f, 17.008f)
                lineTo(15.487f, 17.274f)
                lineTo(15.626f, 16.77f)
                lineTo(14.663f, 16.503f)
                close()
                moveTo(12.005f, 11.613f)
                curveTo(12.005f, 12.089f, 12.213f, 12.668f, 12.463f, 13.212f)
                curveTo(12.722f, 13.775f, 13.063f, 14.377f, 13.398f, 14.924f)
                curveTo(13.734f, 15.472f, 14.07f, 15.973f, 14.32f, 16.337f)
                curveTo(14.446f, 16.519f, 14.551f, 16.667f, 14.624f, 16.77f)
                curveTo(14.661f, 16.822f, 14.69f, 16.862f, 14.71f, 16.889f)
                curveTo(14.72f, 16.903f, 14.728f, 16.914f, 14.733f, 16.921f)
                curveTo(14.736f, 16.925f, 14.738f, 16.927f, 14.739f, 16.929f)
                curveTo(14.74f, 16.93f, 14.741f, 16.931f, 14.741f, 16.932f)
                curveTo(14.741f, 16.932f, 14.741f, 16.932f, 14.741f, 16.932f)
                curveTo(14.741f, 16.932f, 14.741f, 16.932f, 14.742f, 16.933f)
                curveTo(14.742f, 16.933f, 14.742f, 16.933f, 15.144f, 16.636f)
                curveTo(15.547f, 16.34f, 15.547f, 16.34f, 15.547f, 16.34f)
                curveTo(15.547f, 16.34f, 15.547f, 16.34f, 15.547f, 16.34f)
                curveTo(15.547f, 16.34f, 15.547f, 16.34f, 15.547f, 16.34f)
                curveTo(15.547f, 16.339f, 15.546f, 16.339f, 15.546f, 16.338f)
                curveTo(15.545f, 16.337f, 15.543f, 16.334f, 15.541f, 16.331f)
                curveTo(15.536f, 16.325f, 15.529f, 16.315f, 15.519f, 16.302f)
                curveTo(15.501f, 16.276f, 15.473f, 16.238f, 15.438f, 16.188f)
                curveTo(15.367f, 16.09f, 15.266f, 15.946f, 15.144f, 15.769f)
                curveTo(14.899f, 15.415f, 14.575f, 14.93f, 14.251f, 14.401f)
                curveTo(13.926f, 13.871f, 13.607f, 13.307f, 13.372f, 12.794f)
                curveTo(13.126f, 12.261f, 13.005f, 11.854f, 13.005f, 11.613f)
                horizontalLineTo(12.005f)
                close()
                moveTo(13.346f, 8.159f)
                curveTo(13.079f, 8.265f, 12.879f, 8.483f, 12.734f, 8.696f)
                curveTo(12.582f, 8.92f, 12.453f, 9.194f, 12.348f, 9.493f)
                curveTo(12.138f, 10.091f, 12.005f, 10.843f, 12.005f, 11.613f)
                horizontalLineTo(13.005f)
                curveTo(13.005f, 10.949f, 13.121f, 10.31f, 13.292f, 9.825f)
                curveTo(13.377f, 9.581f, 13.471f, 9.39f, 13.561f, 9.258f)
                curveTo(13.658f, 9.115f, 13.718f, 9.087f, 13.715f, 9.088f)
                lineTo(13.346f, 8.159f)
                close()
                moveTo(14.2f, 8.11f)
                curveTo(14.14f, 8.082f, 14.008f, 8.019f, 13.812f, 8.032f)
                curveTo(13.665f, 8.042f, 13.51f, 8.093f, 13.346f, 8.159f)
                lineTo(13.715f, 9.088f)
                curveTo(13.785f, 9.06f, 13.832f, 9.044f, 13.861f, 9.036f)
                curveTo(13.892f, 9.027f, 13.894f, 9.029f, 13.879f, 9.03f)
                curveTo(13.871f, 9.031f, 13.858f, 9.031f, 13.841f, 9.029f)
                curveTo(13.824f, 9.028f, 13.808f, 9.024f, 13.793f, 9.02f)
                curveTo(13.778f, 9.016f, 13.768f, 9.012f, 13.765f, 9.011f)
                curveTo(13.764f, 9.01f, 13.764f, 9.011f, 13.777f, 9.016f)
                lineTo(14.2f, 8.11f)
                close()
                moveTo(14.288f, 8.123f)
                curveTo(14.261f, 8.123f, 14.243f, 8.122f, 14.233f, 8.121f)
                curveTo(14.222f, 8.12f, 14.217f, 8.119f, 14.217f, 8.119f)
                curveTo(14.217f, 8.119f, 14.218f, 8.119f, 14.218f, 8.119f)
                curveTo(14.219f, 8.119f, 14.219f, 8.119f, 14.219f, 8.119f)
                curveTo(14.218f, 8.118f, 14.215f, 8.118f, 14.2f, 8.11f)
                lineTo(13.777f, 9.016f)
                curveTo(13.809f, 9.032f, 13.878f, 9.064f, 13.973f, 9.088f)
                curveTo(14.067f, 9.112f, 14.169f, 9.123f, 14.288f, 9.123f)
                verticalLineTo(8.123f)
                close()
                moveTo(15.144f, 8.317f)
                curveTo(14.854f, 7.91f, 14.854f, 7.91f, 14.854f, 7.91f)
                curveTo(14.854f, 7.91f, 14.854f, 7.91f, 14.854f, 7.91f)
                curveTo(14.854f, 7.91f, 14.854f, 7.91f, 14.854f, 7.91f)
                curveTo(14.854f, 7.91f, 14.855f, 7.909f, 14.855f, 7.909f)
                curveTo(14.855f, 7.909f, 14.855f, 7.909f, 14.855f, 7.909f)
                curveTo(14.856f, 7.909f, 14.855f, 7.909f, 14.855f, 7.909f)
                curveTo(14.854f, 7.91f, 14.851f, 7.912f, 14.847f, 7.914f)
                curveTo(14.84f, 7.919f, 14.827f, 7.928f, 14.809f, 7.938f)
                curveTo(14.774f, 7.96f, 14.723f, 7.99f, 14.661f, 8.019f)
                curveTo(14.529f, 8.082f, 14.394f, 8.123f, 14.288f, 8.123f)
                verticalLineTo(9.123f)
                curveTo(14.61f, 9.123f, 14.903f, 9.012f, 15.092f, 8.921f)
                curveTo(15.191f, 8.874f, 15.274f, 8.827f, 15.332f, 8.791f)
                curveTo(15.362f, 8.773f, 15.385f, 8.757f, 15.403f, 8.746f)
                curveTo(15.411f, 8.74f, 15.419f, 8.735f, 15.424f, 8.731f)
                curveTo(15.427f, 8.729f, 15.429f, 8.728f, 15.431f, 8.727f)
                curveTo(15.432f, 8.726f, 15.433f, 8.725f, 15.434f, 8.725f)
                curveTo(15.434f, 8.725f, 15.434f, 8.724f, 15.434f, 8.724f)
                curveTo(15.435f, 8.724f, 15.435f, 8.724f, 15.435f, 8.724f)
                curveTo(15.435f, 8.724f, 15.435f, 8.724f, 15.435f, 8.724f)
                curveTo(15.435f, 8.724f, 15.435f, 8.723f, 15.144f, 8.317f)
                close()
                moveTo(15.719f, 8.123f)
                curveTo(15.739f, 8.123f, 15.738f, 8.128f, 15.71f, 8.116f)
                curveTo(15.684f, 8.105f, 15.651f, 8.086f, 15.615f, 8.061f)
                curveTo(15.58f, 8.036f, 15.55f, 8.011f, 15.528f, 7.991f)
                curveTo(15.517f, 7.982f, 15.509f, 7.974f, 15.505f, 7.97f)
                curveTo(15.503f, 7.968f, 15.501f, 7.967f, 15.501f, 7.966f)
                curveTo(15.501f, 7.966f, 15.501f, 7.966f, 15.501f, 7.967f)
                curveTo(15.501f, 7.967f, 15.502f, 7.967f, 15.502f, 7.967f)
                curveTo(15.502f, 7.967f, 15.502f, 7.968f, 15.502f, 7.968f)
                curveTo(15.502f, 7.968f, 15.503f, 7.968f, 15.503f, 7.968f)
                curveTo(15.503f, 7.968f, 15.503f, 7.968f, 15.503f, 7.968f)
                curveTo(15.503f, 7.968f, 15.503f, 7.968f, 15.144f, 8.317f)
                curveTo(14.786f, 8.665f, 14.786f, 8.665f, 14.786f, 8.665f)
                curveTo(14.786f, 8.666f, 14.786f, 8.666f, 14.786f, 8.666f)
                curveTo(14.786f, 8.666f, 14.786f, 8.666f, 14.787f, 8.666f)
                curveTo(14.787f, 8.666f, 14.787f, 8.667f, 14.787f, 8.667f)
                curveTo(14.788f, 8.667f, 14.789f, 8.668f, 14.789f, 8.669f)
                curveTo(14.791f, 8.67f, 14.793f, 8.672f, 14.795f, 8.674f)
                curveTo(14.799f, 8.678f, 14.804f, 8.684f, 14.811f, 8.69f)
                curveTo(14.823f, 8.702f, 14.841f, 8.719f, 14.863f, 8.738f)
                curveTo(14.905f, 8.776f, 14.967f, 8.827f, 15.041f, 8.879f)
                curveTo(15.168f, 8.969f, 15.419f, 9.123f, 15.719f, 9.123f)
                verticalLineTo(8.123f)
                close()
                moveTo(16f, 8.317f)
                curveTo(15.5f, 8.311f, 15.5f, 8.31f, 15.5f, 8.31f)
                curveTo(15.5f, 8.31f, 15.5f, 8.31f, 15.5f, 8.31f)
                curveTo(15.5f, 8.309f, 15.5f, 8.309f, 15.5f, 8.309f)
                curveTo(15.5f, 8.308f, 15.5f, 8.308f, 15.5f, 8.307f)
                curveTo(15.5f, 8.306f, 15.5f, 8.305f, 15.5f, 8.304f)
                curveTo(15.5f, 8.302f, 15.5f, 8.3f, 15.5f, 8.299f)
                curveTo(15.5f, 8.296f, 15.5f, 8.293f, 15.501f, 8.292f)
                curveTo(15.501f, 8.288f, 15.501f, 8.286f, 15.502f, 8.284f)
                curveTo(15.502f, 8.284f, 15.503f, 8.275f, 15.51f, 8.26f)
                curveTo(15.517f, 8.244f, 15.538f, 8.206f, 15.585f, 8.172f)
                curveTo(15.637f, 8.134f, 15.69f, 8.123f, 15.719f, 8.123f)
                verticalLineTo(9.123f)
                curveTo(15.887f, 9.123f, 16.044f, 9.075f, 16.175f, 8.979f)
                curveTo(16.3f, 8.888f, 16.374f, 8.773f, 16.417f, 8.681f)
                curveTo(16.459f, 8.589f, 16.479f, 8.503f, 16.488f, 8.445f)
                curveTo(16.493f, 8.415f, 16.496f, 8.389f, 16.498f, 8.368f)
                curveTo(16.499f, 8.358f, 16.499f, 8.349f, 16.499f, 8.342f)
                curveTo(16.5f, 8.338f, 16.5f, 8.334f, 16.5f, 8.331f)
                curveTo(16.5f, 8.33f, 16.5f, 8.328f, 16.5f, 8.327f)
                curveTo(16.5f, 8.326f, 16.5f, 8.326f, 16.5f, 8.325f)
                curveTo(16.5f, 8.325f, 16.5f, 8.324f, 16.5f, 8.324f)
                curveTo(16.5f, 8.324f, 16.5f, 8.324f, 16.5f, 8.324f)
                curveTo(16.5f, 8.323f, 16.5f, 8.323f, 16f, 8.317f)
                close()
                moveTo(15.5f, 7.3f)
                verticalLineTo(8.317f)
                horizontalLineTo(16.5f)
                verticalLineTo(7.3f)
                horizontalLineTo(15.5f)
                close()
                moveTo(16.031f, 6.8f)
                horizontalLineTo(16f)
                verticalLineTo(7.8f)
                horizontalLineTo(16.031f)
                verticalLineTo(6.8f)
                close()
                moveTo(15.531f, 7.3f)
                verticalLineTo(8.317f)
                horizontalLineTo(16.531f)
                verticalLineTo(7.3f)
                horizontalLineTo(15.531f)
                close()
                moveTo(16.031f, 8.317f)
                curveTo(15.531f, 8.323f, 15.531f, 8.323f, 15.531f, 8.324f)
                curveTo(15.531f, 8.324f, 15.531f, 8.324f, 15.531f, 8.324f)
                curveTo(15.531f, 8.324f, 15.531f, 8.325f, 15.531f, 8.325f)
                curveTo(15.531f, 8.326f, 15.531f, 8.326f, 15.531f, 8.327f)
                curveTo(15.531f, 8.328f, 15.531f, 8.33f, 15.531f, 8.331f)
                curveTo(15.531f, 8.334f, 15.531f, 8.338f, 15.531f, 8.342f)
                curveTo(15.532f, 8.349f, 15.532f, 8.358f, 15.533f, 8.368f)
                curveTo(15.535f, 8.389f, 15.537f, 8.415f, 15.542f, 8.445f)
                curveTo(15.552f, 8.503f, 15.571f, 8.589f, 15.614f, 8.681f)
                curveTo(15.657f, 8.773f, 15.731f, 8.888f, 15.856f, 8.979f)
                curveTo(15.986f, 9.075f, 16.144f, 9.123f, 16.312f, 9.123f)
                verticalLineTo(8.123f)
                curveTo(16.341f, 8.123f, 16.394f, 8.134f, 16.446f, 8.172f)
                curveTo(16.493f, 8.206f, 16.514f, 8.244f, 16.521f, 8.26f)
                curveTo(16.528f, 8.275f, 16.529f, 8.284f, 16.529f, 8.284f)
                curveTo(16.529f, 8.286f, 16.53f, 8.288f, 16.53f, 8.292f)
                curveTo(16.53f, 8.293f, 16.53f, 8.296f, 16.531f, 8.299f)
                curveTo(16.531f, 8.3f, 16.531f, 8.302f, 16.531f, 8.304f)
                curveTo(16.531f, 8.305f, 16.531f, 8.306f, 16.531f, 8.307f)
                curveTo(16.531f, 8.308f, 16.531f, 8.308f, 16.531f, 8.309f)
                curveTo(16.531f, 8.309f, 16.531f, 8.309f, 16.531f, 8.31f)
                curveTo(16.531f, 8.31f, 16.531f, 8.31f, 16.531f, 8.31f)
                curveTo(16.531f, 8.31f, 16.531f, 8.311f, 16.031f, 8.317f)
                close()
                moveTo(16.312f, 9.123f)
                curveTo(16.611f, 9.123f, 16.863f, 8.969f, 16.99f, 8.879f)
                curveTo(17.064f, 8.827f, 17.125f, 8.776f, 17.168f, 8.738f)
                curveTo(17.19f, 8.719f, 17.207f, 8.702f, 17.22f, 8.69f)
                curveTo(17.227f, 8.684f, 17.232f, 8.678f, 17.236f, 8.674f)
                curveTo(17.238f, 8.672f, 17.24f, 8.67f, 17.241f, 8.669f)
                curveTo(17.242f, 8.668f, 17.243f, 8.667f, 17.243f, 8.667f)
                curveTo(17.244f, 8.667f, 17.244f, 8.666f, 17.244f, 8.666f)
                curveTo(17.244f, 8.666f, 17.244f, 8.666f, 17.244f, 8.666f)
                curveTo(17.245f, 8.666f, 17.245f, 8.666f, 17.245f, 8.665f)
                curveTo(17.245f, 8.665f, 17.245f, 8.665f, 16.886f, 8.317f)
                curveTo(16.528f, 7.968f, 16.528f, 7.968f, 16.528f, 7.968f)
                curveTo(16.528f, 7.968f, 16.528f, 7.968f, 16.528f, 7.968f)
                curveTo(16.528f, 7.968f, 16.528f, 7.968f, 16.528f, 7.968f)
                curveTo(16.528f, 7.968f, 16.529f, 7.967f, 16.529f, 7.967f)
                curveTo(16.529f, 7.967f, 16.529f, 7.967f, 16.529f, 7.967f)
                curveTo(16.53f, 7.966f, 16.53f, 7.966f, 16.53f, 7.966f)
                curveTo(16.529f, 7.967f, 16.528f, 7.968f, 16.526f, 7.97f)
                curveTo(16.521f, 7.974f, 16.514f, 7.982f, 16.503f, 7.991f)
                curveTo(16.481f, 8.011f, 16.45f, 8.036f, 16.415f, 8.061f)
                curveTo(16.379f, 8.086f, 16.347f, 8.105f, 16.321f, 8.116f)
                curveTo(16.293f, 8.128f, 16.291f, 8.123f, 16.312f, 8.123f)
                verticalLineTo(9.123f)
                close()
                moveTo(16.886f, 8.317f)
                curveTo(16.595f, 8.723f, 16.596f, 8.724f, 16.596f, 8.724f)
                curveTo(16.596f, 8.724f, 16.596f, 8.724f, 16.596f, 8.724f)
                curveTo(16.596f, 8.724f, 16.596f, 8.724f, 16.596f, 8.724f)
                curveTo(16.597f, 8.724f, 16.597f, 8.725f, 16.597f, 8.725f)
                curveTo(16.598f, 8.725f, 16.599f, 8.726f, 16.6f, 8.727f)
                curveTo(16.602f, 8.728f, 16.604f, 8.729f, 16.607f, 8.731f)
                curveTo(16.612f, 8.735f, 16.619f, 8.74f, 16.628f, 8.746f)
                curveTo(16.645f, 8.757f, 16.669f, 8.773f, 16.699f, 8.791f)
                curveTo(16.757f, 8.827f, 16.84f, 8.874f, 16.939f, 8.921f)
                curveTo(17.128f, 9.012f, 17.421f, 9.123f, 17.743f, 9.123f)
                verticalLineTo(8.123f)
                curveTo(17.637f, 8.123f, 17.502f, 8.082f, 17.369f, 8.019f)
                curveTo(17.308f, 7.99f, 17.257f, 7.96f, 17.221f, 7.938f)
                curveTo(17.204f, 7.928f, 17.191f, 7.919f, 17.183f, 7.914f)
                curveTo(17.179f, 7.912f, 17.177f, 7.91f, 17.176f, 7.909f)
                curveTo(17.175f, 7.909f, 17.175f, 7.909f, 17.175f, 7.909f)
                curveTo(17.176f, 7.909f, 17.176f, 7.909f, 17.176f, 7.909f)
                curveTo(17.176f, 7.909f, 17.176f, 7.91f, 17.177f, 7.91f)
                curveTo(17.177f, 7.91f, 17.177f, 7.91f, 17.177f, 7.91f)
                curveTo(17.177f, 7.91f, 17.177f, 7.91f, 17.177f, 7.91f)
                curveTo(17.177f, 7.91f, 17.177f, 7.91f, 16.886f, 8.317f)
                close()
                moveTo(17.743f, 9.123f)
                curveTo(17.861f, 9.123f, 17.964f, 9.112f, 18.057f, 9.088f)
                curveTo(18.153f, 9.064f, 18.221f, 9.032f, 18.254f, 9.016f)
                lineTo(17.831f, 8.11f)
                curveTo(17.816f, 8.118f, 17.813f, 8.118f, 17.812f, 8.119f)
                curveTo(17.811f, 8.119f, 17.812f, 8.119f, 17.812f, 8.119f)
                curveTo(17.813f, 8.119f, 17.813f, 8.119f, 17.813f, 8.119f)
                curveTo(17.813f, 8.119f, 17.809f, 8.12f, 17.798f, 8.121f)
                curveTo(17.787f, 8.122f, 17.77f, 8.123f, 17.743f, 8.123f)
                verticalLineTo(9.123f)
                close()
                moveTo(18.254f, 9.016f)
                curveTo(18.267f, 9.011f, 18.267f, 9.01f, 18.266f, 9.011f)
                curveTo(18.263f, 9.012f, 18.253f, 9.016f, 18.238f, 9.02f)
                curveTo(18.223f, 9.024f, 18.207f, 9.028f, 18.19f, 9.029f)
                curveTo(18.173f, 9.031f, 18.16f, 9.031f, 18.152f, 9.03f)
                curveTo(18.136f, 9.029f, 18.139f, 9.027f, 18.169f, 9.036f)
                curveTo(18.199f, 9.044f, 18.246f, 9.06f, 18.316f, 9.088f)
                lineTo(18.685f, 8.159f)
                curveTo(18.521f, 8.093f, 18.366f, 8.042f, 18.218f, 8.032f)
                curveTo(18.022f, 8.019f, 17.89f, 8.082f, 17.831f, 8.11f)
                lineTo(18.254f, 9.016f)
                close()
                moveTo(18.316f, 9.088f)
                curveTo(18.313f, 9.087f, 18.373f, 9.115f, 18.47f, 9.258f)
                curveTo(18.559f, 9.39f, 18.654f, 9.581f, 18.739f, 9.825f)
                curveTo(18.91f, 10.31f, 19.026f, 10.949f, 19.026f, 11.613f)
                horizontalLineTo(20.026f)
                curveTo(20.026f, 10.843f, 19.893f, 10.091f, 19.683f, 9.493f)
                curveTo(19.578f, 9.194f, 19.449f, 8.92f, 19.297f, 8.696f)
                curveTo(19.152f, 8.483f, 18.952f, 8.265f, 18.685f, 8.159f)
                lineTo(18.316f, 9.088f)
                close()
                moveTo(19.026f, 11.613f)
                curveTo(19.026f, 11.854f, 18.904f, 12.261f, 18.659f, 12.794f)
                curveTo(18.423f, 13.307f, 18.105f, 13.871f, 17.78f, 14.401f)
                curveTo(17.456f, 14.93f, 17.131f, 15.415f, 16.887f, 15.769f)
                curveTo(16.765f, 15.946f, 16.664f, 16.09f, 16.593f, 16.188f)
                curveTo(16.558f, 16.238f, 16.53f, 16.276f, 16.511f, 16.302f)
                curveTo(16.502f, 16.315f, 16.495f, 16.325f, 16.49f, 16.331f)
                curveTo(16.488f, 16.334f, 16.486f, 16.337f, 16.485f, 16.338f)
                curveTo(16.484f, 16.339f, 16.484f, 16.339f, 16.484f, 16.34f)
                curveTo(16.484f, 16.34f, 16.484f, 16.34f, 16.483f, 16.34f)
                curveTo(16.483f, 16.34f, 16.483f, 16.34f, 16.483f, 16.34f)
                curveTo(16.483f, 16.34f, 16.483f, 16.34f, 16.886f, 16.636f)
                curveTo(17.289f, 16.933f, 17.289f, 16.933f, 17.289f, 16.933f)
                curveTo(17.289f, 16.932f, 17.289f, 16.932f, 17.289f, 16.932f)
                curveTo(17.289f, 16.932f, 17.29f, 16.932f, 17.29f, 16.932f)
                curveTo(17.29f, 16.931f, 17.291f, 16.93f, 17.292f, 16.929f)
                curveTo(17.293f, 16.927f, 17.295f, 16.925f, 17.298f, 16.921f)
                curveTo(17.303f, 16.914f, 17.311f, 16.903f, 17.321f, 16.889f)
                curveTo(17.341f, 16.862f, 17.37f, 16.822f, 17.406f, 16.77f)
                curveTo(17.48f, 16.667f, 17.585f, 16.519f, 17.71f, 16.337f)
                curveTo(17.961f, 15.973f, 18.296f, 15.472f, 18.632f, 14.924f)
                curveTo(18.967f, 14.377f, 19.309f, 13.775f, 19.568f, 13.212f)
                curveTo(19.818f, 12.668f, 20.026f, 12.089f, 20.026f, 11.613f)
                horizontalLineTo(19.026f)
                close()
                moveTo(16.404f, 16.77f)
                lineTo(16.544f, 17.274f)
                lineTo(17.508f, 17.008f)
                lineTo(17.368f, 16.503f)
                lineTo(16.404f, 16.77f)
                close()
                moveTo(17.026f, 17.141f)
                curveTo(17.334f, 17.535f, 17.334f, 17.535f, 17.334f, 17.535f)
                curveTo(17.334f, 17.535f, 17.335f, 17.535f, 17.335f, 17.534f)
                curveTo(17.335f, 17.534f, 17.335f, 17.534f, 17.336f, 17.534f)
                curveTo(17.336f, 17.533f, 17.337f, 17.533f, 17.338f, 17.532f)
                curveTo(17.34f, 17.53f, 17.342f, 17.528f, 17.346f, 17.526f)
                curveTo(17.352f, 17.521f, 17.361f, 17.514f, 17.372f, 17.504f)
                curveTo(17.395f, 17.486f, 17.428f, 17.459f, 17.469f, 17.424f)
                curveTo(17.551f, 17.355f, 17.667f, 17.254f, 17.808f, 17.124f)
                curveTo(18.09f, 16.865f, 18.472f, 16.488f, 18.878f, 16.017f)
                curveTo(19.682f, 15.08f, 20.605f, 13.735f, 20.98f, 12.163f)
                lineTo(20.007f, 11.931f)
                curveTo(19.685f, 13.283f, 18.874f, 14.486f, 18.119f, 15.365f)
                curveTo(17.744f, 15.801f, 17.39f, 16.15f, 17.131f, 16.389f)
                curveTo(17.002f, 16.508f, 16.896f, 16.599f, 16.824f, 16.66f)
                curveTo(16.788f, 16.69f, 16.76f, 16.713f, 16.742f, 16.728f)
                curveTo(16.733f, 16.735f, 16.726f, 16.74f, 16.722f, 16.744f)
                curveTo(16.72f, 16.746f, 16.719f, 16.747f, 16.718f, 16.747f)
                curveTo(16.718f, 16.747f, 16.717f, 16.748f, 16.717f, 16.748f)
                curveTo(16.717f, 16.748f, 16.717f, 16.748f, 16.717f, 16.748f)
                curveTo(16.717f, 16.748f, 16.718f, 16.748f, 16.718f, 16.748f)
                curveTo(16.718f, 16.748f, 16.718f, 16.747f, 17.026f, 17.141f)
                close()
                moveTo(20.98f, 12.163f)
                curveTo(21.369f, 10.528f, 20.857f, 9.17f, 20.27f, 8.243f)
                curveTo(19.976f, 7.78f, 19.66f, 7.417f, 19.417f, 7.169f)
                curveTo(19.295f, 7.045f, 19.19f, 6.949f, 19.115f, 6.883f)
                curveTo(19.077f, 6.849f, 19.046f, 6.824f, 19.024f, 6.805f)
                curveTo(19.013f, 6.796f, 19.004f, 6.789f, 18.997f, 6.784f)
                curveTo(18.994f, 6.781f, 18.991f, 6.779f, 18.989f, 6.777f)
                curveTo(18.988f, 6.777f, 18.987f, 6.776f, 18.987f, 6.775f)
                curveTo(18.986f, 6.775f, 18.986f, 6.775f, 18.986f, 6.775f)
                curveTo(18.986f, 6.774f, 18.985f, 6.774f, 18.985f, 6.774f)
                curveTo(18.985f, 6.774f, 18.985f, 6.774f, 18.678f, 7.169f)
                curveTo(18.371f, 7.564f, 18.371f, 7.563f, 18.371f, 7.563f)
                curveTo(18.371f, 7.563f, 18.371f, 7.563f, 18.371f, 7.563f)
                curveTo(18.371f, 7.563f, 18.37f, 7.563f, 18.37f, 7.563f)
                curveTo(18.37f, 7.563f, 18.37f, 7.563f, 18.37f, 7.563f)
                curveTo(18.371f, 7.563f, 18.372f, 7.564f, 18.373f, 7.565f)
                curveTo(18.376f, 7.567f, 18.381f, 7.571f, 18.388f, 7.577f)
                curveTo(18.403f, 7.589f, 18.425f, 7.608f, 18.455f, 7.634f)
                curveTo(18.514f, 7.686f, 18.6f, 7.765f, 18.703f, 7.87f)
                curveTo(18.909f, 8.08f, 19.178f, 8.388f, 19.425f, 8.778f)
                curveTo(19.92f, 9.559f, 20.315f, 10.64f, 20.007f, 11.931f)
                lineTo(20.98f, 12.163f)
                close()
                moveTo(18.723f, 6.671f)
                lineTo(18.561f, 6.656f)
                lineTo(18.472f, 7.652f)
                lineTo(18.633f, 7.667f)
                lineTo(18.723f, 6.671f)
                close()
                moveTo(18.016f, 6.4f)
                verticalLineTo(7.154f)
                horizontalLineTo(19.016f)
                verticalLineTo(6.4f)
                horizontalLineTo(18.016f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF8FC753)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(13.104f, 13.785f)
                curveTo(13.104f, 13.785f, 13.418f, 12.941f, 13.968f, 13.222f)
                curveTo(14.518f, 13.503f, 14.47f, 14.483f, 14.97f, 14.134f)
                curveTo(15.471f, 13.785f, 15.187f, 13.222f, 15.928f, 13.222f)
                curveTo(16.67f, 13.222f, 16.561f, 14.134f, 17.005f, 14.134f)
                curveTo(17.45f, 14.134f, 17.488f, 13.222f, 17.985f, 13.222f)
                curveTo(18.483f, 13.222f, 18.987f, 13.785f, 18.987f, 13.785f)
                lineTo(16.045f, 17.787f)
                lineTo(13.104f, 13.785f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.929f, 18.457f)
                lineTo(7.613f, 18.031f)
                curveTo(7.613f, 18.031f, 8.925f, 18.031f, 9.103f, 18.34f)
                curveTo(9.153f, 18.427f, 9.175f, 18.493f, 9.191f, 18.544f)
                curveTo(9.234f, 18.672f, 9.242f, 18.698f, 9.598f, 18.698f)
                curveTo(10.094f, 18.698f, 9.598f, 18.206f, 9.392f, 18.031f)
                curveTo(9.185f, 17.856f, 9.311f, 17.55f, 9.598f, 17.55f)
                curveTo(9.709f, 17.55f, 9.901f, 17.525f, 10.138f, 17.493f)
                curveTo(10.516f, 17.444f, 11.005f, 17.379f, 11.454f, 17.379f)
                curveTo(12.184f, 17.379f, 11.579f, 18.031f, 11.579f, 18.031f)
                curveTo(11.579f, 18.031f, 12.524f, 18.031f, 12.289f, 17.76f)
                curveTo(12.055f, 17.489f, 13.077f, 17.158f, 13.519f, 17.158f)
                curveTo(13.931f, 17.158f, 15.785f, 17.251f, 16.035f, 17.263f)
                curveTo(16.295f, 17.251f, 18.234f, 17.158f, 18.645f, 17.158f)
                curveTo(19.087f, 17.158f, 20.11f, 17.489f, 19.875f, 17.76f)
                curveTo(19.64f, 18.031f, 20.586f, 18.031f, 20.586f, 18.031f)
                curveTo(20.586f, 18.031f, 19.98f, 17.379f, 20.711f, 17.379f)
                curveTo(21.159f, 17.379f, 21.649f, 17.444f, 22.027f, 17.493f)
                curveTo(22.263f, 17.525f, 22.456f, 17.55f, 22.566f, 17.55f)
                curveTo(22.853f, 17.55f, 22.979f, 17.856f, 22.773f, 18.031f)
                curveTo(22.566f, 18.206f, 22.071f, 18.698f, 22.566f, 18.698f)
                curveTo(22.922f, 18.698f, 22.931f, 18.672f, 22.973f, 18.544f)
                curveTo(22.99f, 18.493f, 23.012f, 18.427f, 23.062f, 18.34f)
                curveTo(23.234f, 18.042f, 24.461f, 18.031f, 24.547f, 18.031f)
                curveTo(24.527f, 17.995f, 24.516f, 17.953f, 24.516f, 17.908f)
                curveTo(24.516f, 17.77f, 24.624f, 17.658f, 24.758f, 17.658f)
                curveTo(24.892f, 17.658f, 25f, 17.77f, 25f, 17.908f)
                curveTo(25f, 18.046f, 24.892f, 18.158f, 24.758f, 18.158f)
                curveTo(24.669f, 18.158f, 24.591f, 18.109f, 24.549f, 18.035f)
                lineTo(24.236f, 18.457f)
                lineTo(24.562f, 18.862f)
                curveTo(24.606f, 18.799f, 24.677f, 18.758f, 24.758f, 18.758f)
                curveTo(24.892f, 18.758f, 25f, 18.87f, 25f, 19.008f)
                curveTo(25f, 19.146f, 24.892f, 19.258f, 24.758f, 19.258f)
                curveTo(24.624f, 19.258f, 24.516f, 19.146f, 24.516f, 19.008f)
                curveTo(24.516f, 18.98f, 24.521f, 18.952f, 24.529f, 18.927f)
                curveTo(24.344f, 18.837f, 24.025f, 18.698f, 23.817f, 18.698f)
                horizontalLineTo(23.24f)
                curveTo(23.385f, 18.698f, 24.185f, 19.226f, 23.943f, 19.454f)
                lineTo(23.902f, 19.493f)
                curveTo(23.664f, 19.719f, 23.354f, 20.014f, 23.062f, 19.853f)
                curveTo(22.753f, 19.683f, 22.566f, 19.454f, 22.566f, 19.454f)
                lineTo(22.324f, 18.698f)
                curveTo(22.324f, 18.698f, 20.895f, 18.329f, 20.895f, 18.585f)
                curveTo(20.895f, 18.84f, 20.891f, 18.965f, 20.384f, 18.965f)
                curveTo(20.1f, 18.965f, 19.826f, 18.917f, 19.585f, 18.875f)
                curveTo(19.395f, 18.841f, 19.225f, 18.811f, 19.087f, 18.811f)
                curveTo(18.89f, 18.811f, 18.584f, 18.872f, 18.358f, 18.917f)
                curveTo(18.226f, 18.944f, 18.12f, 18.965f, 18.08f, 18.965f)
                curveTo(17.972f, 18.965f, 17.393f, 18.939f, 17.79f, 18.698f)
                curveTo(18.187f, 18.457f, 18.278f, 18.206f, 18.278f, 18.206f)
                curveTo(18.278f, 18.206f, 16.69f, 18.442f, 16.062f, 18.457f)
                verticalLineTo(18.457f)
                lineTo(16.034f, 18.457f)
                lineTo(16.006f, 18.457f)
                verticalLineTo(18.457f)
                curveTo(15.383f, 18.442f, 13.887f, 18.206f, 13.887f, 18.206f)
                curveTo(13.887f, 18.206f, 13.978f, 18.457f, 14.375f, 18.698f)
                curveTo(14.771f, 18.939f, 14.193f, 18.965f, 14.084f, 18.965f)
                curveTo(14.044f, 18.965f, 13.939f, 18.944f, 13.806f, 18.917f)
                curveTo(13.58f, 18.872f, 13.275f, 18.811f, 13.077f, 18.811f)
                curveTo(12.939f, 18.811f, 12.769f, 18.841f, 12.58f, 18.875f)
                curveTo(12.338f, 18.917f, 12.064f, 18.965f, 11.781f, 18.965f)
                curveTo(11.274f, 18.965f, 11.27f, 18.84f, 11.27f, 18.585f)
                curveTo(11.27f, 18.329f, 9.841f, 18.698f, 9.841f, 18.698f)
                lineTo(9.598f, 19.454f)
                curveTo(9.598f, 19.454f, 9.412f, 19.683f, 9.103f, 19.853f)
                curveTo(8.81f, 20.014f, 8.5f, 19.719f, 8.263f, 19.493f)
                lineTo(8.222f, 19.454f)
                curveTo(7.98f, 19.226f, 8.779f, 18.698f, 8.925f, 18.698f)
                horizontalLineTo(8.347f)
                curveTo(8.041f, 18.698f, 7.489f, 19.002f, 7.489f, 19.002f)
                lineTo(7.929f, 18.457f)
                close()
                moveTo(7.242f, 18.158f)
                curveTo(7.376f, 18.158f, 7.484f, 18.046f, 7.484f, 17.908f)
                curveTo(7.484f, 17.77f, 7.376f, 17.658f, 7.242f, 17.658f)
                curveTo(7.108f, 17.658f, 7f, 17.77f, 7f, 17.908f)
                curveTo(7f, 18.046f, 7.108f, 18.158f, 7.242f, 18.158f)
                close()
                moveTo(7.242f, 19.258f)
                curveTo(7.376f, 19.258f, 7.484f, 19.146f, 7.484f, 19.008f)
                curveTo(7.484f, 18.87f, 7.376f, 18.758f, 7.242f, 18.758f)
                curveTo(7.108f, 18.758f, 7f, 18.87f, 7f, 19.008f)
                curveTo(7f, 19.146f, 7.108f, 19.258f, 7.242f, 19.258f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFD018)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(15.894f, 2.029f)
                horizontalLineTo(16.094f)
                verticalLineTo(2.244f)
                horizontalLineTo(16.34f)
                verticalLineTo(2.444f)
                horizontalLineTo(16.094f)
                verticalLineTo(2.808f)
                curveTo(16.37f, 2.854f, 16.581f, 3.102f, 16.581f, 3.4f)
                curveTo(16.581f, 3.731f, 16.321f, 4f, 16f, 4f)
                curveTo(15.679f, 4f, 15.419f, 3.731f, 15.419f, 3.4f)
                curveTo(15.419f, 3.106f, 15.624f, 2.861f, 15.894f, 2.81f)
                verticalLineTo(2.444f)
                horizontalLineTo(15.669f)
                verticalLineTo(2.244f)
                horizontalLineTo(15.894f)
                verticalLineTo(2.029f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE31D1C)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(13.747f, 5.226f)
                curveTo(13.467f, 5.226f, 12.877f, 5.525f, 12.877f, 5.525f)
                lineTo(13.335f, 6.543f)
                lineTo(16.104f, 6.439f)
                lineTo(18.873f, 6.543f)
                lineTo(19.332f, 5.525f)
                curveTo(19.332f, 5.525f, 18.742f, 5.226f, 18.462f, 5.226f)
                curveTo(18.339f, 5.226f, 18.323f, 5.153f, 18.306f, 5.072f)
                curveTo(18.283f, 4.969f, 18.258f, 4.851f, 18.001f, 4.851f)
                curveTo(17.82f, 4.851f, 17.692f, 4.881f, 17.588f, 4.905f)
                curveTo(17.431f, 4.942f, 17.33f, 4.966f, 17.184f, 4.851f)
                curveTo(17.178f, 4.846f, 17.171f, 4.841f, 17.165f, 4.836f)
                curveTo(16.929f, 4.65f, 16.684f, 4.456f, 16.287f, 4.456f)
                curveTo(16.207f, 4.456f, 16.148f, 4.531f, 16.104f, 4.651f)
                curveTo(16.06f, 4.531f, 16.001f, 4.456f, 15.922f, 4.456f)
                curveTo(15.525f, 4.456f, 15.279f, 4.65f, 15.043f, 4.836f)
                curveTo(15.037f, 4.841f, 15.031f, 4.846f, 15.025f, 4.851f)
                curveTo(14.879f, 4.966f, 14.777f, 4.942f, 14.62f, 4.905f)
                curveTo(14.516f, 4.881f, 14.388f, 4.851f, 14.207f, 4.851f)
                curveTo(13.951f, 4.851f, 13.925f, 4.969f, 13.903f, 5.072f)
                curveTo(13.885f, 5.153f, 13.87f, 5.226f, 13.747f, 5.226f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFD018)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(15.608f, 3.568f)
                lineTo(15.414f, 3.636f)
                curveTo(14.9f, 3.814f, 14.455f, 3.873f, 14.08f, 3.815f)
                curveTo(13.306f, 3.696f, 12.297f, 4.098f, 12.424f, 4.687f)
                curveTo(12.479f, 4.946f, 12.641f, 5.434f, 12.809f, 5.847f)
                curveTo(13.042f, 6.421f, 13.206f, 6.71f, 13.397f, 6.71f)
                curveTo(13.422f, 6.71f, 13.681f, 6.724f, 13.768f, 6.729f)
                curveTo(13.783f, 6.73f, 13.793f, 6.73f, 13.795f, 6.73f)
                curveTo(14.076f, 6.744f, 14.324f, 6.752f, 14.562f, 6.751f)
                curveTo(15.251f, 6.748f, 15.678f, 6.68f, 15.831f, 6.473f)
                lineTo(15.876f, 6.412f)
                lineTo(15.854f, 6.339f)
                curveTo(15.674f, 5.717f, 15.59f, 4.863f, 15.605f, 3.78f)
                lineTo(15.608f, 3.568f)
                close()
                moveTo(12.707f, 4.623f)
                curveTo(12.645f, 4.334f, 13.434f, 4.019f, 14.037f, 4.112f)
                curveTo(14.412f, 4.169f, 14.838f, 4.126f, 15.313f, 3.983f)
                curveTo(15.311f, 4.945f, 15.389f, 5.727f, 15.55f, 6.33f)
                curveTo(15.412f, 6.402f, 15.05f, 6.449f, 14.561f, 6.451f)
                curveTo(14.328f, 6.452f, 14.086f, 6.445f, 13.809f, 6.431f)
                curveTo(13.812f, 6.431f, 13.525f, 6.415f, 13.426f, 6.411f)
                curveTo(13.423f, 6.407f, 13.419f, 6.403f, 13.415f, 6.398f)
                curveTo(13.389f, 6.368f, 13.357f, 6.319f, 13.32f, 6.255f)
                curveTo(13.248f, 6.127f, 13.164f, 5.946f, 13.077f, 5.731f)
                curveTo(12.915f, 5.332f, 12.758f, 4.861f, 12.707f, 4.623f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFD018)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(16.455f, 3.568f)
                lineTo(16.649f, 3.636f)
                curveTo(17.163f, 3.814f, 17.607f, 3.873f, 17.983f, 3.815f)
                curveTo(18.757f, 3.696f, 19.766f, 4.098f, 19.639f, 4.687f)
                curveTo(19.584f, 4.946f, 19.422f, 5.434f, 19.254f, 5.847f)
                curveTo(19.02f, 6.421f, 18.857f, 6.71f, 18.666f, 6.71f)
                curveTo(18.641f, 6.71f, 18.382f, 6.724f, 18.295f, 6.729f)
                curveTo(18.28f, 6.73f, 18.27f, 6.73f, 18.268f, 6.73f)
                curveTo(17.987f, 6.744f, 17.739f, 6.752f, 17.501f, 6.751f)
                curveTo(16.812f, 6.748f, 16.385f, 6.68f, 16.232f, 6.473f)
                lineTo(16.187f, 6.412f)
                lineTo(16.208f, 6.339f)
                curveTo(16.389f, 5.717f, 16.473f, 4.863f, 16.458f, 3.78f)
                lineTo(16.455f, 3.568f)
                close()
                moveTo(19.356f, 4.623f)
                curveTo(19.418f, 4.334f, 18.628f, 4.019f, 18.026f, 4.112f)
                curveTo(17.65f, 4.169f, 17.225f, 4.126f, 16.75f, 3.983f)
                curveTo(16.752f, 4.945f, 16.674f, 5.727f, 16.513f, 6.33f)
                curveTo(16.651f, 6.402f, 17.013f, 6.449f, 17.502f, 6.451f)
                curveTo(17.734f, 6.452f, 17.977f, 6.445f, 18.254f, 6.431f)
                curveTo(18.251f, 6.431f, 18.538f, 6.415f, 18.637f, 6.411f)
                curveTo(18.64f, 6.407f, 18.644f, 6.403f, 18.648f, 6.398f)
                curveTo(18.674f, 6.368f, 18.706f, 6.319f, 18.743f, 6.255f)
                curveTo(18.815f, 6.127f, 18.899f, 5.946f, 18.986f, 5.731f)
                curveTo(19.148f, 5.332f, 19.305f, 4.861f, 19.356f, 4.623f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF5E5E5E)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(12.837f, 6.471f)
                curveTo(12.837f, 6.416f, 12.805f, 6.315f, 12.735f, 6.129f)
                curveTo(12.639f, 5.873f, 12.573f, 5.795f, 12.433f, 5.71f)
                curveTo(12.362f, 5.666f, 12.334f, 5.629f, 12.301f, 5.5f)
                curveTo(12.274f, 5.396f, 12.247f, 5.316f, 12.216f, 5.241f)
                curveTo(12.21f, 5.226f, 12.196f, 5.196f, 12.183f, 5.167f)
                lineTo(12.183f, 5.167f)
                curveTo(12.17f, 5.138f, 12.157f, 5.109f, 12.153f, 5.099f)
                curveTo(12.132f, 5.045f, 12.123f, 4.996f, 12.123f, 4.918f)
                curveTo(12.123f, 4.829f, 12.146f, 4.757f, 12.208f, 4.627f)
                curveTo(12.245f, 4.549f, 12.249f, 4.539f, 12.262f, 4.506f)
                curveTo(12.289f, 4.44f, 12.303f, 4.382f, 12.303f, 4.324f)
                verticalLineTo(3.939f)
                curveTo(12.303f, 3.714f, 12.312f, 3.7f, 12.422f, 3.715f)
                curveTo(12.433f, 3.716f, 12.444f, 3.718f, 12.455f, 3.72f)
                curveTo(12.451f, 3.719f, 12.508f, 3.73f, 12.522f, 3.732f)
                curveTo(12.548f, 3.735f, 12.57f, 3.733f, 12.591f, 3.723f)
                curveTo(12.631f, 3.705f, 12.66f, 3.67f, 12.73f, 3.566f)
                curveTo(12.763f, 3.517f, 12.798f, 3.522f, 12.923f, 3.583f)
                curveTo(12.941f, 3.592f, 12.952f, 3.597f, 12.963f, 3.602f)
                curveTo(13.091f, 3.661f, 13.18f, 3.662f, 13.256f, 3.57f)
                curveTo(13.373f, 3.428f, 13.449f, 3.437f, 13.591f, 3.574f)
                curveTo(13.66f, 3.642f, 13.696f, 3.668f, 13.74f, 3.674f)
                lineTo(13.744f, 3.675f)
                curveTo(13.791f, 3.682f, 13.794f, 3.682f, 13.926f, 3.601f)
                curveTo(13.935f, 3.62f, 13.955f, 3.627f, 13.987f, 3.634f)
                curveTo(14.029f, 3.644f, 14.092f, 3.648f, 14.134f, 3.641f)
                curveTo(14.17f, 3.635f, 14.194f, 3.625f, 14.211f, 3.59f)
                curveTo(14.267f, 3.589f, 14.333f, 3.588f, 14.41f, 3.588f)
                verticalLineTo(3.488f)
                curveTo(14.312f, 3.488f, 14.23f, 3.489f, 14.164f, 3.492f)
                curveTo(14.159f, 3.488f, 14.153f, 3.482f, 14.146f, 3.476f)
                lineTo(14.146f, 3.476f)
                curveTo(14.109f, 3.444f, 14.053f, 3.394f, 14.026f, 3.402f)
                curveTo(14.023f, 3.403f, 14.012f, 3.412f, 13.997f, 3.425f)
                lineTo(13.997f, 3.425f)
                curveTo(13.974f, 3.446f, 13.941f, 3.475f, 13.91f, 3.495f)
                curveTo(13.778f, 3.575f, 13.773f, 3.578f, 13.754f, 3.575f)
                curveTo(13.736f, 3.573f, 13.712f, 3.554f, 13.657f, 3.501f)
                curveTo(13.48f, 3.329f, 13.34f, 3.313f, 13.182f, 3.505f)
                curveTo(13.142f, 3.554f, 13.096f, 3.553f, 13.002f, 3.51f)
                curveTo(12.992f, 3.506f, 12.982f, 3.501f, 12.965f, 3.492f)
                curveTo(12.797f, 3.411f, 12.723f, 3.401f, 12.65f, 3.509f)
                curveTo(12.593f, 3.595f, 12.568f, 3.625f, 12.553f, 3.632f)
                lineTo(12.55f, 3.633f)
                lineTo(12.549f, 3.633f)
                curveTo(12.546f, 3.635f, 12.541f, 3.634f, 12.498f, 3.626f)
                lineTo(12.472f, 3.622f)
                curveTo(12.459f, 3.619f, 12.447f, 3.617f, 12.435f, 3.616f)
                curveTo(12.252f, 3.591f, 12.206f, 3.662f, 12.206f, 3.939f)
                verticalLineTo(4.324f)
                curveTo(12.206f, 4.367f, 12.195f, 4.413f, 12.173f, 4.468f)
                curveTo(12.161f, 4.498f, 12.156f, 4.508f, 12.121f, 4.583f)
                curveTo(12.053f, 4.726f, 12.026f, 4.809f, 12.026f, 4.918f)
                curveTo(12.026f, 5.009f, 12.037f, 5.071f, 12.064f, 5.137f)
                curveTo(12.069f, 5.149f, 12.083f, 5.182f, 12.097f, 5.214f)
                curveTo(12.11f, 5.241f, 12.122f, 5.268f, 12.127f, 5.281f)
                curveTo(12.157f, 5.351f, 12.182f, 5.427f, 12.208f, 5.525f)
                curveTo(12.248f, 5.68f, 12.291f, 5.739f, 12.384f, 5.796f)
                curveTo(12.505f, 5.87f, 12.557f, 5.93f, 12.645f, 6.165f)
                curveTo(12.691f, 6.287f, 12.719f, 6.373f, 12.733f, 6.427f)
                curveTo(12.736f, 6.438f, 12.738f, 6.447f, 12.739f, 6.455f)
                curveTo(12.725f, 6.466f, 12.727f, 6.474f, 12.731f, 6.496f)
                curveTo(12.735f, 6.503f, 12.736f, 6.506f, 12.737f, 6.508f)
                lineTo(12.739f, 6.511f)
                lineTo(12.739f, 6.511f)
                curveTo(12.745f, 6.518f, 12.745f, 6.518f, 12.752f, 6.523f)
                curveTo(12.754f, 6.525f, 12.757f, 6.527f, 12.76f, 6.529f)
                curveTo(12.758f, 6.529f, 12.757f, 6.528f, 12.755f, 6.527f)
                curveTo(12.761f, 6.534f, 12.769f, 6.543f, 12.778f, 6.556f)
                curveTo(12.873f, 6.68f, 12.993f, 6.68f, 13.107f, 6.56f)
                lineTo(13.038f, 6.49f)
                curveTo(12.963f, 6.569f, 12.911f, 6.569f, 12.854f, 6.494f)
                lineTo(12.837f, 6.471f)
                close()
                moveTo(13.999f, 3.534f)
                lineTo(13.997f, 3.534f)
                lineTo(13.998f, 3.534f)
                lineTo(13.999f, 3.534f)
                close()
                moveTo(19.115f, 6.471f)
                curveTo(19.115f, 6.416f, 19.147f, 6.315f, 19.217f, 6.129f)
                curveTo(19.313f, 5.873f, 19.379f, 5.795f, 19.519f, 5.71f)
                curveTo(19.59f, 5.666f, 19.617f, 5.629f, 19.651f, 5.5f)
                curveTo(19.677f, 5.396f, 19.705f, 5.316f, 19.736f, 5.241f)
                curveTo(19.742f, 5.226f, 19.755f, 5.196f, 19.768f, 5.167f)
                curveTo(19.782f, 5.138f, 19.795f, 5.109f, 19.799f, 5.099f)
                curveTo(19.82f, 5.045f, 19.829f, 4.996f, 19.829f, 4.918f)
                curveTo(19.829f, 4.829f, 19.806f, 4.757f, 19.744f, 4.627f)
                curveTo(19.707f, 4.549f, 19.702f, 4.539f, 19.689f, 4.506f)
                curveTo(19.663f, 4.44f, 19.649f, 4.382f, 19.649f, 4.324f)
                verticalLineTo(3.939f)
                curveTo(19.649f, 3.714f, 19.64f, 3.7f, 19.53f, 3.715f)
                curveTo(19.519f, 3.716f, 19.508f, 3.718f, 19.497f, 3.72f)
                curveTo(19.501f, 3.719f, 19.444f, 3.73f, 19.43f, 3.732f)
                curveTo(19.404f, 3.735f, 19.382f, 3.733f, 19.361f, 3.723f)
                curveTo(19.321f, 3.705f, 19.292f, 3.67f, 19.222f, 3.566f)
                curveTo(19.189f, 3.517f, 19.154f, 3.522f, 19.029f, 3.583f)
                curveTo(19.011f, 3.592f, 19f, 3.597f, 18.989f, 3.602f)
                curveTo(18.861f, 3.661f, 18.771f, 3.662f, 18.696f, 3.57f)
                curveTo(18.579f, 3.428f, 18.502f, 3.437f, 18.361f, 3.574f)
                curveTo(18.292f, 3.642f, 18.256f, 3.668f, 18.212f, 3.674f)
                lineTo(18.208f, 3.675f)
                curveTo(18.161f, 3.682f, 18.158f, 3.682f, 18.026f, 3.601f)
                curveTo(18.017f, 3.62f, 17.997f, 3.627f, 17.965f, 3.634f)
                curveTo(17.923f, 3.644f, 17.86f, 3.648f, 17.817f, 3.641f)
                curveTo(17.782f, 3.635f, 17.757f, 3.625f, 17.741f, 3.59f)
                curveTo(17.685f, 3.589f, 17.619f, 3.588f, 17.542f, 3.588f)
                verticalLineTo(3.488f)
                curveTo(17.64f, 3.488f, 17.722f, 3.489f, 17.788f, 3.492f)
                curveTo(17.793f, 3.488f, 17.799f, 3.482f, 17.806f, 3.476f)
                curveTo(17.843f, 3.444f, 17.899f, 3.394f, 17.926f, 3.402f)
                curveTo(17.929f, 3.403f, 17.94f, 3.412f, 17.955f, 3.425f)
                lineTo(17.955f, 3.425f)
                lineTo(17.955f, 3.425f)
                curveTo(17.977f, 3.445f, 18.008f, 3.473f, 18.038f, 3.492f)
                lineTo(18.042f, 3.495f)
                curveTo(18.174f, 3.575f, 18.179f, 3.578f, 18.198f, 3.575f)
                curveTo(18.215f, 3.573f, 18.24f, 3.554f, 18.295f, 3.501f)
                curveTo(18.472f, 3.329f, 18.612f, 3.313f, 18.77f, 3.505f)
                curveTo(18.81f, 3.554f, 18.856f, 3.553f, 18.949f, 3.51f)
                curveTo(18.96f, 3.506f, 18.97f, 3.501f, 18.987f, 3.492f)
                curveTo(19.155f, 3.411f, 19.229f, 3.401f, 19.302f, 3.509f)
                curveTo(19.359f, 3.595f, 19.383f, 3.625f, 19.399f, 3.632f)
                lineTo(19.401f, 3.633f)
                lineTo(19.403f, 3.633f)
                curveTo(19.406f, 3.635f, 19.411f, 3.634f, 19.454f, 3.626f)
                lineTo(19.48f, 3.622f)
                curveTo(19.493f, 3.619f, 19.505f, 3.617f, 19.517f, 3.616f)
                curveTo(19.7f, 3.591f, 19.746f, 3.662f, 19.746f, 3.939f)
                verticalLineTo(4.324f)
                curveTo(19.746f, 4.367f, 19.757f, 4.413f, 19.779f, 4.468f)
                curveTo(19.791f, 4.498f, 19.795f, 4.508f, 19.831f, 4.583f)
                curveTo(19.899f, 4.726f, 19.926f, 4.809f, 19.926f, 4.918f)
                curveTo(19.926f, 5.009f, 19.914f, 5.071f, 19.888f, 5.137f)
                curveTo(19.883f, 5.149f, 19.869f, 5.182f, 19.854f, 5.214f)
                curveTo(19.842f, 5.241f, 19.83f, 5.268f, 19.824f, 5.281f)
                curveTo(19.795f, 5.351f, 19.77f, 5.427f, 19.744f, 5.525f)
                curveTo(19.704f, 5.68f, 19.661f, 5.739f, 19.568f, 5.796f)
                curveTo(19.446f, 5.87f, 19.395f, 5.93f, 19.307f, 6.165f)
                curveTo(19.261f, 6.287f, 19.233f, 6.373f, 19.219f, 6.427f)
                curveTo(19.216f, 6.438f, 19.214f, 6.447f, 19.213f, 6.455f)
                curveTo(19.227f, 6.466f, 19.225f, 6.474f, 19.221f, 6.496f)
                curveTo(19.217f, 6.503f, 19.216f, 6.506f, 19.215f, 6.508f)
                lineTo(19.213f, 6.511f)
                curveTo(19.207f, 6.518f, 19.207f, 6.518f, 19.2f, 6.523f)
                curveTo(19.198f, 6.525f, 19.195f, 6.527f, 19.192f, 6.529f)
                curveTo(19.194f, 6.529f, 19.195f, 6.528f, 19.197f, 6.527f)
                curveTo(19.191f, 6.534f, 19.183f, 6.543f, 19.173f, 6.556f)
                curveTo(19.079f, 6.68f, 18.959f, 6.68f, 18.845f, 6.56f)
                lineTo(18.914f, 6.49f)
                curveTo(18.989f, 6.569f, 19.04f, 6.569f, 19.097f, 6.494f)
                lineTo(19.115f, 6.471f)
                close()
            }
            path(fill = SolidColor(Color(0xFF272727))) {
                moveTo(13.774f, 17.885f)
                lineTo(13.835f, 17.389f)
                curveTo(14.909f, 17.52f, 15.627f, 17.586f, 15.988f, 17.586f)
                curveTo(16.533f, 17.611f, 17.183f, 17.571f, 17.937f, 17.467f)
                lineTo(18.005f, 17.962f)
                curveTo(17.223f, 18.07f, 16.544f, 18.112f, 15.977f, 18.086f)
                curveTo(15.6f, 18.086f, 14.869f, 18.019f, 13.774f, 17.885f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun SanMarinoPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.SanMarino,
            contentDescription = "San Marino Flag"
        )
    }
}
